import React from 'react';

import { useNavigate } from 'react-router-dom';
import { generateColumns, LimitsTable } from './LimitsTable';
import { adminApi } from '../../api';

function AdminLimits({ t, user, env }) {
  const navigate = useNavigate();
  const columns = generateColumns(t, env);
  const pageTitle = t('admin.limits.titlePlural');

  return (
    <LimitsTable
      t={t}
      user={user}
      makeNew={() => navigate('/admin/limit/new')}
      generateRowUrl={(row) => `/admin/limit/${row.original.uuid}/detail`}
      pageTitle={pageTitle}
      columns={columns}
      fetchData={adminApi.fetchLimits}
    />
  );
}

export default AdminLimits;
